import React from 'react';
import { i18n } from 'config/locales';
import ValidationElement from 'components/Form/ValidationElement';
import { ValidationElementProps } from 'components/Form/ValidationElement/ValidationElement';
import { CommonOnUpdate, CommonOnError, CommonRequired } from 'types/props';
import { ErrorCode } from 'redux/modules/application/reducers/error';
import RadioGroup from 'components/Form/RadioGroup';
import Radio from 'components/Form/Radio';
import Show from 'components/Form/Show';
import Textarea from 'components/Form/Textarea';
import { LegalInvestigationsClearanceLevelModel } from 'forms/sections/legal/shared/clearance/legalClearanceLevel';

interface Props extends Partial<LegalInvestigationsClearanceLevelModel>, ValidationElementProps {
  onUpdate?: CommonOnUpdate
  onError?: CommonOnError
  required?: CommonRequired
  attribute?: string
  disabled?: boolean
  className?: string
}

export default class ClearanceLevel extends ValidationElement<Props> {
  update = (queue: Partial<LegalInvestigationsClearanceLevelModel>) => {
    this.props.onUpdate({
      Level: this.props.Level,
      Explanation: this.props.Explanation,
      ...queue,
    });
  };

  updateLevel = (values: LegalInvestigationsClearanceLevelModel['Level']) => {
    this.update({
      Level: values,
    });
  };

  updateExplanation = (values: LegalInvestigationsClearanceLevelModel['Explanation']) => {
    this.update({
      Explanation: values,
    });
  };

  render() {
    return (
      <div className={this.props.className}>
        <RadioGroup
          className="clearance-levels option-list option-list-vertical"
          selectedValue={(this.props.Level || {}).value}
          onError={this.props.onError}
          required={this.props.required}
          disabled={this.props.disabled}
          attribute={`${this.props.attribute}.Level`}
        >
          <Radio
            label={i18n.t('legal.investigations.history.label.level.none')}
            value="None"
            className="clearance-level-none"
            onUpdate={this.updateLevel}
            onError={this.props.onError}
          />
          <Radio
            label={i18n.t('legal.investigations.history.label.level.confidential')}
            value="Confidential"
            className="clearance-level-confidential"
            onUpdate={this.updateLevel}
            onError={this.props.onError}
          />
          <Radio
            label={i18n.t('legal.investigations.history.label.level.secret')}
            value="Secret"
            className="clearance-level-secret"
            onUpdate={this.updateLevel}
            onError={this.props.onError}
          />
          <Radio
            label={i18n.t('legal.investigations.history.label.level.topsecret')}
            value="Top Secret"
            className="clearance-level-topsecret"
            onUpdate={this.updateLevel}
            onError={this.props.onError}
          />
          <Radio
            label={i18n.t('legal.investigations.history.label.level.sci')}
            value="Sensitive Compartmented Information"
            className="clearance-level-sci"
            onUpdate={this.updateLevel}
            onError={this.props.onError}
          />
          <Radio
            label={i18n.t('legal.investigations.history.label.level.q')}
            value="Q"
            className="clearance-level-q"
            onUpdate={this.updateLevel}
            onError={this.props.onError}
          />
          <Radio
            label={i18n.t('legal.investigations.history.label.level.l')}
            value="L"
            className="clearance-level-l"
            onUpdate={this.updateLevel}
            onError={this.props.onError}
          />
          <Radio
            label={i18n.t('legal.investigations.history.label.level.foreign')}
            value="Issued by foreign country"
            className="clearance-level-foreign"
            onUpdate={this.updateLevel}
            onError={this.props.onError}
          />
          <Radio
            label={i18n.t('legal.investigations.history.label.level.other')}
            value="Other"
            className="clearance-level-other"
            onUpdate={this.updateLevel}
            onError={this.props.onError}
          />
        </RadioGroup>

        <Show when={(this.props.Level || {}).value === 'Other'}>
          <p>{i18n.t('legal.investigations.history.heading.clearanceExplanation')}</p>
          <Textarea
            name="Explanation"
            {...this.props.Explanation}
            disabled={this.props.disabled}
            className="legal-investigations-history-clearance-explanation"
            onUpdate={this.updateExplanation}
            onError={this.props.onError}
            required={this.props.required}
            attribute={`${this.props.attribute}.Explanation`}
          />
        </Show>
      </div>
    );
  }
}

ClearanceLevel.defaultProps = {
  className: 'investigative-clearance-levels',
  Level: {},
  Explanation: {},
  onUpdate: (queue) => {},
  onError: (value, arr: ErrorCode[]) => arr,
};

ClearanceLevel.errors = [];
